<template>
    <b-row>
        <b-col>
            <b-row id="filters-search">
                <div class="name-filter">
                    <input type="text" class="form-control" placeholder="🔎   Pesquise por nome..." v-model="searchInput">
                </div>
            </b-row>

            <b-row id="filters-row">
                <div class="type-filter">
                    <v-select id="city-search" v-model="groupSelect" :options="['Todos os grupos','Vendedor','Cliente B2B','Cliente B2C','Cliente Revenda']"></v-select>
                </div>
                <div class="type-filter">
                    <v-select id="city-search" v-model="divisaoSelect" :options="['Todas as divisões','Auto','Cargo','Manutenção','Metal','MD Marcenaria','MD Marmoraria','RV Contrução','RV Mobilidade']"></v-select>
                </div>
                <div class="type-filter">
                    <v-select id="city-search" v-model="estadoSelect" :options="['Todos os estados','Acre','Alagoas','Amapá','Amazonas','Bahia','Ceará','Distrito Federal','Espírito Santo','Goiás','Maranhão','Mato Grosso','Mato Grosso do Sul','Minas Gerais','Pará','Paraíba','Paraná','Pernambuco','Piauí','Rio de Janeiro','Rio Grande do Norte','Rio Grande do Sul','Rondônia','Roraima','Santa Catarina','São Paulo','Sergipe','Tocantins']"></v-select>
                </div>
            </b-row>

            <b-row>
                <b-table 
                    class="contacts-table"
                    striped
                    hover
                    sticky-header
                    fixed
                    head-variant="dark"
                    :items="items" 
                    :fields="fields"
                >
                    <template v-slot:cell(action)="data">
                        <button v-show="!!data.item.check === true" class="btn btn-danger btn-table" @click="delItem(data)"><i class="fas fa-times"></i>      Remover</button>
                        <button v-show="!!data.item.check === false" class="btn btn-primary btn-table"  @click="addItem(data)"><i class="fas fa-plus"></i>     Adicionar</button>
                    </template>
                </b-table>
            </b-row>
            <b-row id="count-row">
                <div id="total-count">
                    Total: <b>{{totalChecked}}</b> contato<span v-show="totalChecked > 1">s</span> adicionado<span v-show="totalChecked > 1">s</span>.
                </div>
                <div class="add-or-remove-all">
                    <button class="btn btn-primary" @click="addAll()">Adicionar todos</button>
                    <button class="btn btn-danger" @click="delAll()">Remover todos</button>
                </div>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
export default {
    props: {
        wallets: {
            type: Array,
            default: []
        }
    },
    data(){
        return {
            at_wallets: this.wallets,
            groupSelect: 'Todos os grupos',
            divisaoSelect: 'Todas as divisões',
            estadoSelect: 'Todos os estados',
            elementos: 1,
            searchGrupo: 0,
            searchDivisao: 0,
            searchEstado: 0,
            items: [],
            fields: [
                {
                    key: 'action',
                    label: 'Ação',
                    class: 'text-center',
                    thStyle: {width: '120px'} 
                },
                {
                    key: 'name',
                    label: 'Nome',
                    class: 'text-center',
                    sortable: true,
                    thStyle: { 
                        width: '200px' 
                    } 
                },
                {
                    key: 'phone',
                    label: 'Telefone',
                    class: 'text-center',
                    sortable: true
                },
                {
                    key: 'grupo',
                    label: 'Grupo',
                    class: 'text-center',
                    sortable: true
                },
            ],
            searchInput: ''
        }
    },
    methods:{
        addItem (data) {
            data.item.check = true
            const { name, phone } = data.item
            this.$emit('addClient', { name, phone });

        },
        delItem (data) {
            data.item.check = false
            const { name, phone } = data.item
            this.$emit('removeClient', { name, phone });
            
        },
        addAll () {
            this.items.forEach(item => {
                item.check = true
                const { name, phone } = item
                this.$emit('addClient', { name, phone });
            })
        },
        delAll () {
            this.items.forEach(item => {
                item.check = false
            });
            this.$emit('removeAllClients');
        },
    },
    computed: {

        totalChecked () {
            let total = 0
            this.wallets.forEach(el => {
                if(!!el.check) total++
            });
            return total
        }

    },
    watch:{
        groupSelect (value) {

            if(value != null && value != '' && value != 'Todos os grupos') {
                let newItems = [];
                this.at_wallets.forEach(item => {
                    if(item.grupo === value) {
                        newItems.push(item);
                    }

                    if(this.searchDivisao != 0 && this.searchDivisao != null && this.searchDivisao != '' && this.searchDivisao != 'Todas as divisões'){
                        if(item.divisao === this.searchDivisao) {
                            newItems.push(item);
                        }
                    }

                    if(this.searchEstado != 0 && this.searchEstado != null && this.searchEstado != '' && this.searchEstado != 'Todos os estados'){
                        if(item.estado === this.searchEstado) {
                            newItems.push(item);
                        }
                    }

                });
                this.items = newItems;
            } 
            else {
                this.items = this.at_wallets;
                this.searchGrupo = 0;
            }
        },
        divisaoSelect (value) {
            if(value != null && value != '' && value != 'Todas as divisões') {
                let newItems = [];
                this.at_wallets.forEach(item => {
                    if(item.divisao === value) {
                        newItems.push(item);
                    }

                    if(this.searchGrupo != 0 && this.searchGrupo != null && this.searchGrupo != '' && this.searchGrupo != 'Todos os grupos'){
                        if(item.grupo === this.searchGrupo) {
                            newItems.push(item);
                        }
                    }

                    if(this.searchEstado != 0 && this.searchEstado != null && this.searchEstado != '' && this.searchEstado != 'Todos os estados'){
                        if(item.estado === this.searchEstado) {
                            newItems.push(item);
                        }
                    }

                });
                this.items = newItems;
            } 
            else {
                this.items = this.at_wallets;
                this.searchDivisao = 0;
            }
        },
        estadoSelect (value) {
            if(value != null && value != '' && value != 'Todos os estados') {
                let newItems = [];
                this.at_wallets.forEach(item => {
                    if(item.estado === value) {
                        newItems.push(item);
                    }

                    if(this.searchGrupo != 0 && this.searchGrupo != null && this.searchGrupo != '' && this.searchGrupo != 'Todos os grupos'){
                        if(item.grupo === this.searchGrupo) {
                            newItems.push(item);
                        }
                    }

                    if(this.searchDivisao != 0 && this.searchDivisao != null && this.searchDivisao != '' && this.searchDivisao != 'Todas as divisões'){
                        if(item.divisao === this.searchDivisao) {
                            newItems.push(item);
                        }
                    }

                });
                this.items = newItems;
            }
            else {
                this.items = this.at_wallets;
                this.searchEstado = 0;
            }
        },
        searchInput(){
            let keyword = this.searchInput.toLowerCase();
            this.groupSelect = 'Todos os grupos';
            this.items = this.at_wallets.filter(row => {
                const name = row.name.toLowerCase();
                const phone = row.phone;
                return (name.includes(keyword) ||
                        phone.includes(keyword)
                )
            })
        }
    },
    mounted () {
        this.items = this.at_wallets
    }

}
</script>

<style scoped>
    #filters-search {
        display: flex;
        flex-direction: row;
        justify-content: right;
        margin: 5px 0px 20px 0px;
    }

    #city-search {
        width: 200px;
    }
    
    #filters-row{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 5px 0px 5px 0px;
    }

    #count-row{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 10px;
    }
    #total-count{
        align-self: center;
    }
    .contacts-table>thead>tr{
        background: #1C869A;
        color: white;
    }
    td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 1px;
    }
    .b-table-sticky-header{
        max-height: 35vh;
    }
    .add-or-remove-all button{
        border-radius: 10px !important;
    }
    .btn-table{
        border-radius: 10px !important;
        font-size: 10px;
        margin: 0px;
    }
</style>